<template>
  <div class="my_logo_set">
    <p :class="type == 'one_level' ? 'set_one_level' : 'set_two_level'">
      <span
        v-text="title"
        class="title"
        :style="{
          width: titleWidth + 'px'
        }"
      ></span>
      <span class="logoSelect" style="position: relative;">
        <my_img_cover :firstModel.sync="logo_url" :fileType="1"></my_img_cover>
        <div
          class="imgPart"
          :style="{
            backgroundImage:logo_url?'url('+ logo_url +')':'url(/static/image/logo.jpg)',
          }"
        ></div>
        <!-- <img :src="logo_url?logo_url:'/static/image/logo.jpg'" /> -->
        <span class="tipWrods">
          <i class="el-icon-refresh"></i>{{$t('components_my_img_index_2313')}}</span>
      </span>
    </p>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_logo_set',
  props: {
    title: {
      // 组件的标题
      type: String,
      default: ''
    },
    type: {
      // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    logoUrl: {}
  },
  data() {
    return {
      logo_url: this.logoUrl
    };
  },
  watch: {
    logo_url(val) {
      this.$emit('update:logoUrl', val);
    },
    logoUrl(val) {
      this.logo_url = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.my_logo_set {
  margin-top: 20px;
  .logoSelect {
    cursor: pointer;
    display: inline-block;
    width: 250px;
    overflow: hidden;
    border-color: #e3e2e8;
    flex-grow: 1;
    height: 136px;
    border: 1px dashed #e3e2e8;
    .imgPart {
      width: 100%;
      height: 100%;
      cursor: pointer;
      -moz-background-size: contain;
      -o-background-size: contain;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .tipWrods{
      position: absolute;
      bottom: 0;
      right: 0;
      color: #fff;
      font-size: 13px;
      line-height: 28px;
      width: 60px;
      height: 28px;
      pointer-events: none;
      text-align: center;
      background: rgba(101,125,215,.9);
    }
  }
  .logoSelect:hover{
    border: 1px dashed #6d83d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_logo_set/index.vue